export const ROUTE_PATHS = {
  HOME: '/',
  TRACKING: '/sledzenie',
  SERVICES: '/uslugi',
  ABOUT: '/o-nas',
  CONTACT: '/kontakt',
  ORDER: '/zamowienie',
  ADMIN: '/admin',
} as const;

export interface Shipment {
  id: string;
  trackingNumber: string;
  recipient: {
    name: string;
    address: string;
  };
  amount: {
    payout: number;
    deposit: number;
    total: number;
    currency: string;
  };
  status: 'paid' | 'unpaid' | 'in_transit' | 'delivered';
  deliveryType: string;
  createdAt: string;
  estimatedDelivery?: string;
}

export interface TrackingResult {
  found: boolean;
  shipment?: Shipment;
  error?: string;
}

export interface CashOrder {
  id?: string;
  senderName: string;
  senderPhone: string;
  senderEmail: string;
  senderAddress: string;
  amount: number;
  currency: string;
  deliveryType: 'express' | 'standard';
  notes?: string;
  createdAt?: string;
  status?: 'pending' | 'confirmed' | 'in_transit' | 'delivered';
}

export const formatCurrency = (amount: number, currency: string = 'EUR'): string => {
  return new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const getStatusColor = (status: Shipment['status']): string => {
  const statusColors: Record<Shipment['status'], string> = {
    paid: 'text-green-600 bg-green-50 border-green-200',
    unpaid: 'text-destructive bg-destructive/10 border-destructive/20',
    in_transit: 'text-amber-600 bg-amber-50 border-amber-200',
    delivered: 'text-green-600 bg-green-50 border-green-200',
  };
  return statusColors[status] || 'text-muted-foreground bg-muted border-border';
};

export const getStatusLabel = (status: Shipment['status']): string => {
  const statusLabels: Record<Shipment['status'], string> = {
    paid: 'Opłacone',
    unpaid: 'Nieopłacone',
    in_transit: 'W trakcie dostawy',
    delivered: 'Dostarczone',
  };
  return statusLabels[status] || 'Nieznany';
};
